export default "__VITE_ASSET__C73rZ4sw__"